// The public mobile homepage already contains usable HTML navigation.
// Load the application immediately elsewhere, or when this page needs its widgets.
import { startWebVitalsSampling } from 'MODULES/lib/sentryDeferred';

require('../../config/landing.icons.js');
require('../../config/category.icons.js');
require('../../config/ico.icons.js');
require('../../config/home-preview.icons.js');

// Web Vitals RUM starts from the boot script, so the mobile home preview (app not loaded yet) is measured too.
startWebVitalsSampling();

let application;
const startApplication = () => {
    if (!application) {
        const styles = Array.from(document.querySelectorAll('link[data-app-styles]')).map(link => new Promise((resolve, reject) => {
            if (link.sheet) {
                link.media = 'all';
                resolve();
                return;
            }
            link.onload = resolve;
            link.onerror = () => {
                link.setAttribute('data-load-failed', '');
                reject(new Error('Stylesheet download failed'));
            };
            link.media = 'all';
            if (!link.getAttribute('href')) link.href = link.getAttribute('data-app-href');
            if (link.hasAttribute('data-load-failed')) {
                link.removeAttribute('data-load-failed');
                // Retry the original URL after an earlier background CSS failure.
                const { href } = link;
                link.removeAttribute('href');
                link.href = href;
            }
        }));
        application = Promise.all(styles).then(() => import(/* webpackChunkName: "application" */ './application')).catch(() => {
            application = null;
            let retry = document.querySelector('[data-home-preview-retry]');
            if (!retry) {
                retry = document.createElement('button');
                retry.type = 'button';
                retry.textContent = window.location.pathname.startsWith('/ru') ? 'Повторить загрузку' : 'Mēģināt ielādēt vēlreiz';
                retry.addEventListener('click', () => window.location.reload());
                document.body.appendChild(retry);
            }
            retry.className = 'btn btn-primary';
            retry.style.cssText = 'position:fixed;bottom:6rem;left:1rem;right:1rem;z-index:3000';
            retry.hidden = false;
            const menu = document.querySelector('[data-home-preview-menu]');
            if (menu) menu.removeAttribute('aria-busy');
        });
    }
    return application;
};

const preview = document.getElementById('ppHomePreview');
if (!preview || window.location.hash || window.__PP_HOME_PREVIEW_MENU__) {
    startApplication();
} else {
    preview.addEventListener('click', event => {
        if (event.target.closest('[data-home-preview-menu], [data-home-preview-retry], a[href="#signin"]')) {
            startApplication();
        }
    });
    window.addEventListener('hashchange', startApplication, { once: true });
    window.addEventListener('resize', () => {
        if (!window.matchMedia('(max-width: 767px)').matches) startApplication();
    });
    const lowerContent = preview.querySelector('[data-home-preview-listings]');
    if (typeof IntersectionObserver === 'undefined' || !lowerContent) {
        startApplication();
    } else {
        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
                observer.disconnect();
                startApplication();
            }
        }, { rootMargin: '150px 0px' });
        observer.observe(lowerContent);
    }
}
